import { ErrorBoundary } from '@/components/error/error-boundary.js';
import { NotFoundPage } from '@/components/error/not-found-page.js';
import { AppShell } from '@/components/layout/app-shell.js';
import { Outlet, createRootRoute } from '@tanstack/react-router';

export const Route = createRootRoute({
  component: RootLayout,
  notFoundComponent: NotFoundPage,
});

function RootLayout() {
  return (
    <ErrorBoundary>
      <AppShell>
        <Outlet />
      </AppShell>
    </ErrorBoundary>
  );
}
